import { JwtTokenFn } from "@me8eon/authentication";
import { EnvironmentConfig } from "@me8eon/config";
import axios, {AxiosResponse} from "axios";
import { aiConfig } from "me-at-eon/src";

export type CallDetails = {
    "callId": string;
    "pGuid": string;
    "start": string;
    "end": string;
    "deviceName": string;
}

export type CallInsights = {
    "callId": string;
    "callerIdentity": string;
    "insights": string[]
}

export const getTrueDemApi: <T>(
    path: string,
    tokenFn: JwtTokenFn,
    queryParams?: Record<string, any>,
    headers?: Record<string, any>
) => Promise<AxiosResponse<T>> = async (path, tokenFn, queryParams, headers) => {
    const { jwtTokenFn } = aiConfig;
    return axios.get(`${EnvironmentConfig.gatewayURL}/proxy/${path}`, {
        headers: {
            Authorization: `Bearer ${await tokenFn()}`,
            "Content-Type": "application/json",
            Accept: "application/json",
            ...headers,
            'x-proxy': EnvironmentConfig.trueDemApiProxy,
            "x-proxy-token": await jwtTokenFn()
        },
        params: queryParams,
    });
};
